// v1.1.0 · Pie de página de la web pública
import React from 'react';
import { Link } from 'react-router-dom';
import { nav, contactData, LOGO } from '../../data/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--line)] bg-[var(--paper)]">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <img src={LOGO} alt="Analytica" className="h-24 w-auto" />
          <p className="mt-4 max-w-[36ch] text-[15px] leading-[1.6] text-[var(--ink-2)]">
            Fábrica de software en Quito. Sistemas a la medida para empresas de Ecuador y Latinoamérica.
          </p>
        </div>
        <div>
          <h3 className="text-[15px] font-bold">Analytica</h3>
          <ul className="mt-4 space-y-2.5 text-[15px] text-[var(--ink-2)]">
            {nav.map((n) => <li key={n.href}><a href={n.href} className="hover:text-[var(--ink)]">{n.label}</a></li>)}
          </ul>
        </div>
        <div>
          <h3 className="text-[15px] font-bold">Clientes</h3>
          <ul className="mt-4 space-y-2.5 text-[15px] text-[var(--ink-2)]">
            <li><Link to="/login" className="hover:text-[var(--ink)]">Portal de clientes</Link></li>
            <li><Link to="/checkout" className="hover:text-[var(--ink)]">Pagar en línea</Link></li>
            <li><Link to="/transferencia" className="hover:text-[var(--ink)]">Pagar por transferencia</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-[15px] font-bold">Contacto</h3>
          <ul className="mt-4 space-y-2.5 text-[15px] text-[var(--ink-2)]">
            <li><a href={contactData.whatsappLink} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--ink)]">WhatsApp {contactData.whatsapp}</a></li>
            <li><a href={`mailto:${contactData.email}`} className="break-all hover:text-[var(--ink)]">{contactData.email}</a></li>
            <li>{contactData.address}, Quito</li>
            <li><Link to="/privacidad" className="hover:text-[var(--ink)]">Política de privacidad</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--line)]">
        <p className="mx-auto max-w-[1240px] px-5 pb-24 pt-6 text-[13px] text-[var(--ink-2)] sm:px-8 lg:pb-6">
          © {year} Analytica. Todos los derechos reservados. Hecho en Quito, a 0°13′ del ecuador.
        </p>
      </div>
    </footer>
  );
}
